module.exports = __webpack_public_path__ + "static/media/sourcesanspro-regular-webfont.01c34960.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-regular-webfont.ttf
// module id = 273
// module chunks = 0